import { ApolloQueryResult } from '@apollo/client';
import { Network } from '@capacitor/network';
import { UseFetchMoreOverrideProps, UseFetchMoreOverrideReturn } from './types';
import { useShowOfflineWarningMessage } from 'Hooks';
import { isConnected } from 'NetworkContext';

export const useFetchMoreOverride = <TQuery, TVariables>({ showOfflineWarningMessage, fetchMore }: UseFetchMoreOverrideProps<TQuery, TVariables>): UseFetchMoreOverrideReturn<TQuery, TVariables> => {
	const showOfflineWarningMessageFunc = useShowOfflineWarningMessage();

	return async (variables?: Partial<TVariables> | undefined): Promise<ApolloQueryResult<TQuery> | undefined> => {
		const connected = isConnected();
		if (connected) {
			const queryResult = await fetchMore({ variables });
			return queryResult;
		}

		if (showOfflineWarningMessage) {
			showOfflineWarningMessageFunc();
		}

		return undefined;
	};
};

